import { render, staticRenderFns } from "./ExtraOption.vue?vue&type=template&id=7b0b64de&"
import script from "./ExtraOption.vue?vue&type=script&lang=ts&"
export * from "./ExtraOption.vue?vue&type=script&lang=ts&"
import style0 from "./ExtraOption.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
